import Request from '../request';

export interface ChatMessage {
  sender: 'user' | 'bot';
  text: string;
  timestamp: string;
  modelUsed?: string;
}

export interface ChatHistoryItem {
  role: 'user' | 'assistant' | 'model';
  content: string;
}

export class AdminChatbotService {
  /**
   * Send message from admin user to backend Agentic AI endpoint
   */
  static async sendMessage(
    message: string,
    history: ChatHistoryItem[] = [],
    model: string = 'default'
  ): Promise<ChatMessage> {
    const timeStr = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    try {
      const fd = new FormData();
      fd.append('message', message);
      fd.append('model', model);

      history.forEach((h, idx) => {
        fd.append(`history[${idx}][role]`, h.role);
        fd.append(`history[${idx}][content]`, h.content);
      });

      const response: any = await Request.post('/api/ai/admin-chat', fd);

      const replyText = response?.reply || response?.data?.reply;
      const modelUsed = response?.model_used || response?.data?.model_used;

      if (replyText) {
        return {
          sender: 'bot',
          text: replyText,
          timestamp: timeStr,
          modelUsed: modelUsed
        };
      }

      return {
        sender: 'bot',
        text: 'Maaf, terjadi masalah saat memproses respon dari AI Assistant.',
        timestamp: timeStr
      };
    } catch (error: any) {
      console.error('Admin AI Chat Service Error:', error);
      const errorMsg = typeof error === 'string' ? error : (error?.message || 'Network Error');
      return {
        sender: 'bot',
        text: 'Terjadi kesalahan koneksi ke server AI: ' + errorMsg,
        timestamp: timeStr
      };
    }
  }
}
